import { Router } from './router.js';
import { deviceService } from './services/deviceService.js';

document.addEventListener('DOMContentLoaded', () => {
  const appElement = document.getElementById('app');
  if (!appElement) return;

  // Initialize device identification token across storage layers
  deviceService.getDeviceToken().catch(() => {});

  // Register PWA service worker
  if ('serviceWorker' in navigator && window.location.protocol.startsWith('http')) {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  }

  // Start client router
  const router = new Router(appElement);
  router.init();
});
